const page_add_row = {
    namespaced: true,
    state: {
      isShow:false,
      ids:[],
      row:null
    },
    mutations: {
      SET_isShow(state, val) {
        state.isShow = val;
      },
      SET_ids(state, arr) {
        state.ids = arr;
      },
      SET_row(state, row) {
        state.row = row;
      }

  
  
  
    },
    actions: {
  
  
    }
  
  };
  
  
  export default page_add_row;
  


// WEBPACK FOOTER //
// ./src/vuex/modules/page_add_row.js